/* Fotos de la escena de la ficha (tema "Haimarket - 251026 B", 25-oct-2026; ver snippets/hai-ficha-escena.liquid).
   La pista se desliza sola (scroll-snap nativo): este script solo mueve los puntos y las flechas de escritorio,
   pide las fotos que faltan al primer gesto y hace que un toque en la foto abra la galería del tema en esa foto
   (el mismo botón de «N fotos», que siempre apunta a la foto a la vista). Sin este script las fotos se deslizan
   igual. El tema no rehace la escena al cambiar de combo (solo precio, SKU y existencia), así que basta con
   prepararla una vez. */
(() => {
  const preparar = (fig) => {
    const pista = fig.querySelector('.hai-escena__pista');
    if (!pista) return;
    const laminas = [...pista.querySelectorAll('.hai-escena__lamina')];
    const puntos = [...fig.querySelectorAll('.hai-escena__punto')];
    const ant = fig.querySelector('.hai-escena__flecha--ant');
    const sig = fig.querySelector('.hai-escena__flecha--sig');
    const abrir = fig.querySelector('.hai-escena__fotos-boton');
    let actual = 0;

    const marcar = (i) => {
      actual = i;
      puntos.forEach((p, k) => p.classList.toggle('is-activo', k === i));
      if (ant) ant.classList.toggle('is-limite', i === 0);
      if (sig) sig.classList.toggle('is-limite', i === laminas.length - 1);
      if (abrir && laminas[i]) abrir.dataset.mediaId = laminas[i].dataset.mediaId;
    };

    // Qué foto está a la vista: leer scrollLeft al desplazar es barato, y solo se toca el DOM cuando cambia la foto.
    pista.addEventListener('scroll', () => {
      const i = Math.max(0, Math.min(laminas.length - 1, Math.round(pista.scrollLeft / (pista.clientWidth || 1))));
      if (i !== actual) marcar(i);
    }, { passive: true });

    const ir = (i) => {
      const destino = Math.max(0, Math.min(laminas.length - 1, i));
      const suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      pista.scrollTo({ left: destino * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
    };
    if (ant) ant.addEventListener('click', () => ir(actual - 1));
    if (sig) sig.addEventListener('click', () => ir(actual + 1));

    // Las fotos que faltan se piden al primer gesto (tocar, pasar el mouse, foco): así ya están cuando llegan.
    // Antes, las lazy de una pista horizontal se pedían recién al asomar y la foto aparecía en blanco un instante.
    const pedir = () => pista.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
    ['pointerdown', 'pointerenter', 'touchstart'].forEach((ev) => fig.addEventListener(ev, pedir, { once: true, passive: true }));
    fig.addEventListener('focusin', pedir, { once: true });

    // Un toque en la foto abre la galería del tema en esa foto. Deslizar no cuenta como toque (el navegador no
    // manda clic tras desplazar).
    if (abrir) {
      pista.addEventListener('click', (e) => {
        const lamina = e.target.closest('.hai-escena__lamina');
        if (!lamina) return;
        abrir.dataset.mediaId = lamina.dataset.mediaId;
        abrir.click();
      });
    }
    marcar(0);
  };

  const todas = () => document.querySelectorAll('[data-hai-fotos]').forEach((fig) => {
    if (fig.dataset.haiListo) return;
    fig.dataset.haiListo = '1';
    preparar(fig);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas);
  else todas();
})();
